var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Common',{scopedSlots:_vm._u([{key:"transport",fn:function(){return [_c('h2',[_vm._v(_vm._s(_vm.$t('track.trackWay.kazakhstan.h2')))]),_c('p',[_vm._v(_vm._s(_vm.$t('track.trackWay.kazakhstan.p1')))]),_c('p',[_vm._v(_vm._s(_vm.$t('track.trackWay.kazakhstan.p2')))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }